// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chat-venue[data-v-3fbb272b]{max-width:280px;display:flex;align-items:center;justify-content:center;padding:15px;border:1px solid var(--q4s-neutral-200);border-radius:4px;margin-bottom:8px}.chat-venue img[data-v-3fbb272b]{width:70px;margin-right:15px}.chat-venue p[data-v-3fbb272b]{font-style:normal;font-weight:400;font-size:14px;line-height:20px;font-weight:500;text-align:initial}", ""]);
// Exports
module.exports = exports;
